const { DELAY_DEBOUNCE, CLASS_NO_DISPLAY } = require('../../../../js/consts');

const {
	default: { breakSmall, breakXtraSmall },
} = require('../../../../js/sass-variables');
const {
	mediaQueryMin,
	initControllerLink,
	trackGtm,
} = require('../../../../js/functions');
const asyncImport = require('util/asyncImport').default;

const CLASS_CURRENT = 'active';
const CLASS_HIDDEN = 'hidden';
const CLASS_DOTS_AFTER = 'dots-after';

module.exports = {
	async init() {
		this.isDynamic = this.root.dataset.dynamic;

		this.firstButton = this.root.querySelector('.pages-nav--first');
		this.lastButton = this.root.querySelector('.pages-nav--last');
		this.numbersContainer = this.root.querySelector('.pages-nav--numbers');
		this.numbers =
			this.numbersContainer.getElementsByClassName('pages-nav--number');
		this.count = this.numbers.length;
		this.halfSize = this.root.dataset.halfSize;
		this.current = this.getCurrent();
		this.update();
		await asyncImport(this, 'debounce');
		window.addEventListener(
			'resize',
			this.debounce(this.update.bind(this), DELAY_DEBOUNCE),
		);
		if (this.isDynamic) this.initPreviousNext();
		initControllerLink(this);

		//Gtm Tracking
		this.widgetName = this.root.dataset.widget;

		if (this.widgetName) {
			this.firstButton.addEventListener('click', e => {
				trackGtm({
					eventCategory: 'content-navigation',
					eventAction: e.target.innerText + ' page',
					eventLabel: this.widgetName,
				});
			});
			this.lastButton.addEventListener('click', e => {
				trackGtm({
					eventCategory: 'content-navigation',
					eventAction: e.target.innerText + ' page',
					eventLabel: this.widgetName,
				});
			});
			Array.from(this.numbers).forEach(element => {
				element.addEventListener('click', () => {
					trackGtm({
						eventCategory: 'content-navigation',
						eventAction: 'page ' + element.innerText,
						eventLabel: this.widgetName,
					});
				});
			});
		}
	},
	setDynamicPagination(current, count, clickCallback) {
		this.count = count;
		this.current = current;
		this.clickCallback = clickCallback;
		this.update();
	},
	setActivePage(page) {
		this.current = page;
		this.update();
	},
	dynamicRender() {
		this.limit = this.getDisplayableNumbersLimit();
		this.numbers = [];
		this.numbersContainer.innerHTML = '';
		const list = this.getPagesList();
		const ellipsisList = this.getEllipsisIndexes(list);

		list.forEach((page, i) => {
			const isCurrent = page === this.current;
			const hasEllipsis = ellipsisList.includes(i);
			const element = document.createElement(isCurrent ? 'p' : 'button');
			element.classList.add('pages-nav--number');
			if (isCurrent) element.classList.add(CLASS_CURRENT);
			if (hasEllipsis) element.classList.add(CLASS_DOTS_AFTER);
			element.innerHTML = page + 1;
			if (this.clickCallback)
				element.addEventListener('click', () => this.clickCallback(page));
			this.numbers.push(element);
			this.numbersContainer.appendChild(element);
		});
		this.updatePreviousNext();
	},
	initPreviousNext() {
		this.firstButton.addEventListener('click', () => {
			this.clickCallback(0);
		});
		this.lastButton.addEventListener('click', () => {
			this.clickCallback(this.count);
		});
	},
	updatePreviousNext() {
		this.firstButton.disabled = this.current === 0;
		this.lastButton.disabled = this.current === this.count;
	},
	getPagesList() {
		const { lowLimit, highLimit } = this.getRange();
		const pages = [0];
		for (let page = lowLimit; page <= highLimit; page++) {
			if (page > 0) pages.push(page);
		}
		if (this.count > 0) pages.push(this.count);
		return pages;
	},
	update() {
		const isHidden = this.count < 1;
		this.root.classList.toggle(CLASS_NO_DISPLAY, isHidden);
		if (isHidden) return;
		this.limit = this.getDisplayableNumbersLimit();
		if (this.isDynamic) this.dynamicRender();
		else this.render();
	},
	getCurrent() {
		const current = Array.from(this.numbers).findIndex(number => {
			return number.dataset.current;
		});
		return current;
	},
	getDisplayableNumbersLimit() {
		if (this.halfSize) {
			if (mediaQueryMin(breakXtraSmall)) return 8;
			return 6;
		} else {
			if (mediaQueryMin(breakSmall)) return 10;
			if (mediaQueryMin(breakXtraSmall)) return 8;
			return 6;
		}
	},
	getRange() {
		const margin = (this.limit - 4) / 2;
		let lowLimit = this.current - margin;
		let highLimit = this.current + margin;
		if (lowLimit < 2) {
			highLimit -= lowLimit - 1;
			lowLimit = 1;
		}
		if (highLimit > this.count - 2) {
			lowLimit -= highLimit - this.count + 1;
			highLimit = this.count - 1;
		}
		const beforeLastNumber = this.numbers[highLimit];
		const firstNumber = this.numbers[0];
		return {
			margin,
			lowLimit,
			highLimit,
			beforeLastNumber,
			firstNumber,
		};
	},
	getEllipsisIndexes(list) {
		const indexes = [];
		const max = list.length - 1;
		if (max > 2) {
			if (list[1] !== list[0] + 1) indexes.push(0);
			if (list[max] !== list[max - 1] + 1) indexes.push(max - 1);
		}
		return indexes;
	},
	render() {
		const { lowLimit, highLimit, beforeLastNumber, firstNumber } =
			this.getRange();
		Array.from(this.numbers).forEach((number, i) => {
			if (i !== this.current && i !== 0 && i < this.count - 1) {
				if (i < lowLimit || i > highLimit) {
					number.classList.add(CLASS_HIDDEN);
				} else {
					number.classList.remove(CLASS_HIDDEN);
				}
			}
			number.classList.remove(CLASS_DOTS_AFTER);
		});
		if (lowLimit > 1) {
			firstNumber.classList.add(CLASS_DOTS_AFTER);
		}
		if (highLimit < this.count - 2) {
			beforeLastNumber.classList.add(CLASS_DOTS_AFTER);
		}
	},
};
